var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function Svg7(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 400,
    zoomAndPan: "magnify",
    viewBox: "0 0 300 299.999988",
    height: 400,
    preserveAspectRatio: "xMidYMid meet",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "7930bdd9f8"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 0.390625 0 L 299.640625 0 L 299.640625 299.25 L 0.390625 299.25 Z M 0.390625 0 ",
    clipRule: "nonzero"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#7930bdd9f8)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#000000",
    d: "M 150.015625 299.25 C 67.351562 299.25 0.390625 231.828125 0.390625 149.625 C 0.390625 67.421875 67.351562 0 150.015625 0 C 232.679688 0 299.640625 66.960938 299.640625 149.625 C 299.640625 232.289062 232.21875 299.25 150.015625 299.25 Z M 150.015625 9.234375 C 72.433594 9.234375 9.628906 72.042969 9.628906 149.625 C 9.628906 227.207031 72.433594 290.015625 150.015625 290.015625 C 227.601562 290.015625 290.40625 227.207031 290.40625 149.625 C 290.40625 72.042969 227.136719 9.234375 150.015625 9.234375 Z M 150.015625 9.234375 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(Svg7);
export default __webpack_public_path__ + "static/media/7.056e47adf7e4db2e78d0f3f1cd8c9862.svg";
export { ForwardRef as ReactComponent };